import React, { memo } from "react";
import { $UserAddPermissions, ACTIONS } from "@store/user-store";
import { useUnit } from "effector-react";

import { NavLink } from "react-router-dom";
import { ControlRequestTraining } from "@feature/control-request-training";
import styles from "@scss/pages/study-center.module.scss";

const ControlRequestTrainingPage: React.FC = memo(() => {
  const permissions = useUnit($UserAddPermissions);

  return (
    <div className={styles.StudyCenterMain}>
      <div className={styles.head}>
        <div className={styles.tabs}>
          {permissions.hasPermission(
            ACTIONS.companyApplicationsForTraining_allowedToShow
          ) && (
            <NavLink to="/study-center">
              Формирование заявок на обучение
            </NavLink>
          )}
          <div className={styles.tabs_active}>Заявки на обучение</div>
        </div>
      </div>
      <ControlRequestTraining />
    </div>
  );
});

export default ControlRequestTrainingPage;
